var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_36074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9091 19.509C30.9191 19.4102 28.7409 19.4102 28.7409 18.024C28.7409 16.1434 31.5128 13.6684 35.9678 10.9952C37.3534 10.104 40.2253 8.71835 40.2253 6.8371C40.2253 5.3521 39.1359 4.26335 36.8591 4.56023C34.6809 4.8571 31.3147 6.3421 26.8603 10.104C22.2072 13.9652 17.8516 20.4002 17.8516 26.7359C17.8516 33.1709 22.2072 39.6059 29.2366 39.6059C34.8791 39.6059 39.7303 35.349 39.7303 29.5077C39.7297 25.0527 36.6609 19.9052 31.9091 19.509Z",
    fill: "#00CC61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9922 16.7252C17.1791 16.3002 16.2872 16.0221 15.3247 15.9421C14.3347 15.8433 12.1566 15.8433 12.1566 14.4571C12.1566 12.5765 14.9285 10.1015 19.3835 7.42833C20.7697 6.53708 23.6404 5.15146 23.6404 3.27021C23.6404 1.78521 22.551 0.696458 20.2741 0.993333C18.096 1.29021 14.7297 2.77521 10.2754 6.53708C5.62285 10.3983 1.2666 16.8333 1.2666 23.1696C1.2666 29.6046 5.62223 36.0396 12.6516 36.0396C14.3041 36.0396 15.8879 35.6721 17.3022 35.009C15.9154 32.5015 15.176 29.6002 15.176 26.7365C15.1766 23.2002 16.3154 19.7708 17.9922 16.7252Z",
    fill: "#00CC61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_36074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.746094 0.275146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialQuotes);
export default __webpack_public_path__ + "static/media/testimonial-quotes.8257849f3e39542d9c29b1378762deb0.svg";
export { ForwardRef as ReactComponent };